import React, { Component } from 'react';
import './styles/css/app.css';

import {api} from "./variables"


class Nav extends Component {


  render() {

    const createTagLinks = api.links.map(link => 
      <li className="tag-button" key={link.tag}>
        <a href={`/blog/${link.url}`}>{link.tag}</a>
      </li>)
console.log(api, "API")
    return (
        <nav>
          <img src={api.logo}/>
          <h2>Blog</h2>
          <ul>
         
            {createTagLinks}
            <li><a href="http://www.igeno.com">Home</a></li>
          </ul>
 
        </nav>
    );
  }
}

export default Nav;
